import { login, logout, getInfo, forgotPass, confirmForgotPass } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { Ability, AbilityBuilder } from '@casl/ability';
import Cookies from 'js-cookie'

const state = {
  token: getToken(),
  account_id: null,
  name: '',
  surname: '',
  email: '',
  role: '',
  rules: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ACCOUNT_ID: (state, accountId) => {
    state.account_id = accountId
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_SURNAME: (state, surname) => {
    state.surname = surname
  },
  SET_EMAIL: (state, email) => {
    state.email = email
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_RULES: (state, rules) => {
    state.rules = rules
  }
}

const actions = {
  // user login
  login ({ commit }, userInfo) {
    const { username, password } = userInfo

    return new Promise((resolve, reject) => {
      login({ username, password }).then(
        response => {
          if (response.account.role === 'Provider') {
            reject('Permission denied!')
            return
          }
          commit('SET_TOKEN', response.token)
          commit('SET_ACCOUNT_ID', response.account.id)
          commit('SET_ROLE', response.account.role)
          setToken(response.token)
          resolve()
        }
      ).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo (context, payload) {

    return new Promise((resolve, reject) => {
      getInfo().then(data => {
        if (!data) {
          reject(Error('Verification failed, please Login again.'))
        }

        context.commit('SET_NAME', data.account.name)
        context.commit('SET_SURNAME', data.account.surname)
        context.commit('SET_EMAIL', data.account.email)
        context.commit('SET_ROLE', data.account.role)
        context.commit('SET_RULES', data.rules)
        context.commit('SET_ACCOUNT_ID', data.account.id)

        const ability = new Ability([]);
        ability.update(data.rules || []);
        const today = new Date();
        const passExpireDate = new Date(data.account.password_expire)
        //console.log('data.account',data.account.role);
        
        
        if( today > passExpireDate && data.account.role!=='EMN Client') {
          context.dispatch("app/openChangePassword", {title:'Your password is expired! Please change it.', force:true}, {root:true})
        }
        
        resolve(data)
       

      }).catch(error => {
        reject(error)
      })
    })
  },

  
  forgotPass ({ commit }, data) {
    return new Promise((resolve, reject) => {
      forgotPass(data).then(data => {
        if (!data) {
          reject(Error('Verification failed'))
        }

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

    
  confirmForgotPass ({ commit }, data) {
    return new Promise((resolve, reject) => {
      confirmForgotPass(data).then(data => {
        if (!data) {
          reject(Error('Verification failed'))
        }

        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).finally(data => {
        commit('SET_TOKEN', '')
        commit('SET_NAME', '')
        commit('SET_SURNAME', '')
        commit('SET_EMAIL', '')
        commit('SET_ROLE', '')
        commit('SET_ACCOUNT_ID', '')
        removeToken()
        resolve()
        Cookies.set('choosed_sponsor', null)
      })
      // resetRouter()
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_NAME', '')
      commit('SET_SURNAME', '')
      commit('SET_EMAIL', '')
      commit('SET_ROLE', '')
      commit('SET_ACCOUNT_ID', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
